export default "__VITE_ASSET__Dz0FqNU1__"